import {
  FETCH_MODULES,
  FETCH_MODULES_RESOLVED
} from '../actions/modules';

const initialState = {
  modules: [],
  meta: null,
  loading: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MODULES:
      return {
        ...state,
        loading: true
      };
    case FETCH_MODULES_RESOLVED:
      return {
        ...state,
        modules: action.modules,
        meta: action.meta,
        loading: false
      };
    default:
      return state;
  }
};

export default reducer; 